import {isSuggestedParticipantsTabSelected} from '../SuggestedParticipants/isSuggestedParticipantsTabSelected';

/**
 * Checks if the category participants filter tab is active.
 *
 * @param {Object} filterParams - The filter parameters.
 * @param {Object} suggestedFilterParams - The suggested filter parameters.
 * @return {boolean} True if the category participants filter tab is active, false otherwise.
 */
export function isCategoryParticipantsFilterTabActive(filterParams, suggestedFilterParams) {
    return !!Object.keys(filterParams?.categories ?? {}).length && !isSuggestedParticipantsTabSelected(filterParams, suggestedFilterParams);
}
